import { Component, OnInit } from '@angular/core';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../_services/auth.service';
import { AlertModalService } from 'src/app/shared/services/alert-modal.service';

@Component({
  selector: 'tangram-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss']
})
export class EmailConfirmationComponent implements OnInit {
  logoPath = appConfig.logoImg; // To store logo path
  token: string = ""; // To store token
  message: string = "Your email addresss is being verified."
  userId = "";
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private alertModalService: AlertModalService,
  ) {
    this.token = this.activatedRoute.snapshot.params['token'];
  }

  /**
   * Called when component being called
   */
  ngOnInit() {
    this.verifyEmail(); // verify email
  }

  /**
   * Verify email
   */
  verifyEmail() {
    this.authService.verifyEmail(this.token).subscribe((data: any) => {
      // if response is success then redirect to login page otherwise display message in modal
      if (!data.success) {
        this.showPopup(data.message, data.userId);
      } else {
        this.router.navigate(['login']);
      }
      this.message = "";
    }, () => {
      this.message = "";
    });
  }

  /**
   * Show message in sweet modal
   * @param message message to be displayed
   * @param userId userId to be used for sending email
   */
  showPopup(message, userId) {
    this.userId = userId;
    this.alertModalService.confirm({
      message: message,
      cancelText: 'OK',
      confirmText: 'Resend verification email',
    }).subscribe(confirmed => {
      if (confirmed) this.showMessageInSweetModal();
      else this.redirectToConfiguration();
    });
  }

  /**
   * Resend verification email
   * @param userId
   */
  resendVerificationEmail(userId: string) {
    this.authService.resendVerificationEmail(userId).subscribe((res: any) => {
      this.showPopup(res.message, userId);
    });
  }

  showMessageInSweetModal(){
    this.resendVerificationEmail(this.userId);
  }

  redirectToConfiguration(){
    // No-op: modal is already closed by the service
  }

}
